import isEmpty from 'lodash.isempty';
import React from 'react';
import PropTypes from 'prop-types';
import { generateReactKey } from '../../../utils/shared/commonUtils';

const Section = ({ className, itemClassName, items, header }) =>
    !isEmpty(items) && (
        <div className={`section ${className}`}>
            {!isEmpty(header) && header}
            {items.map((item, index) => (
                <div key={generateReactKey(index)} className={itemClassName}>
                    {item}
                </div>
            ))}
        </div>
    );

Section.defaultProps = {
    className: '',
    itemClassName: '',
    items: [],
    header: {},
};

Section.propTypes = {
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    items: PropTypes.array,
    header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default Section;
